import { render } from "./CollaboratorsPage.vue?vue&type=template&id=c4ec562e&ts=true"
import script from "./CollaboratorsPage.vue?vue&type=script&lang=ts"
export * from "./CollaboratorsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__